/** Premium Component */

import { FC, useState } from "react";
import { BaseProps } from "./text";
import GText from "./GText";
import { css } from "@emotion/react";

interface Props {
  text?: string;
  once?: boolean;
  duration?: number;
}

const GTextExplosive: FC<Props & BaseProps> = (props) => {
  const [explodeAnimation, setExplodeAnimation] = useState("");

  const styles = css`
    margin: 0;
    white-space: pre;

    & div {
      display: inline-block;
    }

    .letter {
      display: inline-block;
      pointer-events: none;
      transition: transform 350ms ease;
    }

    &:has(.fancy:hover) div:not(.fancy) {
      opacity: 0.2;
    }

    .fancy:hover .letter {
      transition-duration: 800ms;
    }

    ${explodeAnimation}
  `;

  const toggleHoverClass = (event: React.MouseEvent<HTMLDivElement>) => {
    const element = event.target as HTMLElement;
    element.classList.toggle("fancy");

    /** handling animation transforms */
    const word = element.innerText;
    const animationClassArr = [];

    for (let i = 1; i <= word.length; i++) {
      const integer = Math.round(Math.random()) ? 1 : -1;

      const x = Math.floor(Math.random() * 100 * integer);
      const y = Math.floor(Math.random() * 50 * integer);
      const z = Math.floor(Math.random() * 10 * integer);

      const animationClass = `
        .fancy:hover > .letter:nth-child(${i}) {
        transform: translate(${x}%, ${y}%) rotate(${z}deg);
    }`;

      animationClassArr.push(animationClass);
    }

    const animationClass = animationClassArr.join("");

    setExplodeAnimation(animationClass);
  };

  const splitIntoWords = () => {
    return props.text?.split(" ").map((word, i) => {
      const wordIntoLetters = () =>
        word.split("").map((letter, i) => (
          <span className="letter" key={i}>
            {letter}
          </span>
        ));

      return (
        <div
          onMouseEnter={toggleHoverClass}
          onMouseLeave={toggleHoverClass}
          key={i}
          className="word"
        >
          {wordIntoLetters()}{" "}
        </div>
      );
    });
  };

  return (
    <GText {...props}>
      <div css={styles}>{splitIntoWords()}</div>
    </GText>
  );
};

GTextExplosive.defaultProps = {
  text: "Subscribe To Grooody",
  color: "#fff",
  once: true,
  fontSize: 30,
};

export default GTextExplosive;

// We need to add the below in framer
/*
addPropertyControls(TextFadeIn, {
    text: {
        title: "Text",
        type: ControlType.String,
        defaultValue: "Subscribe to Grooody",
    },
    color: {
        title: "Color",
        type: ControlType.Color,
        defaultValue: "#000",
    },
    letterSpacing: {
        title: "Letter",
        type: ControlType.Number,
    },
    fontSize: {
        title: "Font Size",
        type: ControlType.Number,
        defaultValue: 46,
    },
    fontFamily: {
        title: "Font Family",
        type: ControlType.Font,
        defaultValue: "Sigmar",
    },
})


*/
